import React from "react";
import { CourseResource } from "../../../stores/CoursesStore/Types";

interface Props {
  course: CourseResource;
  onOpen: (course: CourseResource) => void;
}

const LockedCourseCard: React.FC<Props> = ({ course, onOpen }) => {
  const ariaLabel = `Locked badge. Activate to see how to earn it for ${course.name}.`;

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
      event.preventDefault();
      onOpen(course);
    }
  };

  return (
    <div
      className="bd-card locked"
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      onClick={() => onOpen(course)}
      onKeyDown={handleKeyDown}
    >
      <div className="bd-disc is-locked">
        <span className="ph-mark">Locked</span>
      </div>
      <div className="bd-name">Locked</div>
    </div>
  );
};

export default LockedCourseCard;
